import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import TenantsPage from "./pages/TenantsPage.js";
import TenantHealthPage from "./pages/TenantHealthPage.js";
import TenantDetailPage from "./pages/TenantDetailPage.js";
import CreateTenantPage from "./pages/CreateTenantPage.js";

export const operacionesRoutes = (
  <Route element={<RequireModuleAccess module="operaciones" />}>
    <Route path="/salud" element={<TenantHealthPage />} />
    <Route path="/clientes" element={<TenantsPage />} />
    <Route path="/clientes/nuevo" element={<CreateTenantPage />} />
    <Route path="/clientes/:id" element={<TenantDetailPage />} />
  </Route>
);
